// /mobile-cycle — Mobile Cycle Works, Inc. (Ashley, OH)
// Vintage motorcycle restoration bench.
// Skin: walnut / leather / brass — vintage & weathered.
import VerticalCockpit from "@/components/VerticalCockpit";
import { PALETTES } from "@/config/AssetSpine";
import { VERTICAL_CONFIG } from "@/config/verticalConfig";

export default function MobileCycle() {
  return (
    <VerticalCockpit
      config={VERTICAL_CONFIG.MOBILE_CYCLE}
      palette={PALETTES.MOBILE_CYCLE}
      testPrefix="mc"
    />
  );
}
